
import { t } from '@/i18n'
import store from '@/store'
import api from '@/utils/api'
// import { Message, MessageBox } from 'element-ui'
import { Message } from 'element-ui'

/**
 * @description: 原子开始配送任务，后端锁定站点槽位并返回航线
 */
export async function startDeliveryTask (form) {
  const params = new URLSearchParams()
  params.append('site_id', form.site_id)
  params.append('shop_id', form.shop_id)
  params.append('order_id', form.order_id)
  params.append('plane_id', form.plane_id)
  const res = await api.post('startDeliveryTask', params)
  if (res.data.status === 1) {
    // Refresh failures must not turn a committed task allocation into a failed request.
    await Promise.allSettled(['fetchSiteList', 'fetchRouteList', 'fetchPaidOrderList'].map(action => store.dispatch(action)))
    Message.success(t(res.data.msg))
  } else {
    Message.error(t(res.data.msg))
  }
  return res
}

export async function prepareStandaloneRoute (form) {
  const params = new URLSearchParams()
  Object.entries(form).forEach(([key, value]) => params.append(key, value))
  const res = await api.post('prepareStandaloneRoute', params)
  if (res.data.status !== 1) throw new Error(res.data.msg || '航线分配失败')
  return res.data
}

export async function getStandaloneRoute (form) {
  const params = new URLSearchParams()
  Object.entries(form).forEach(([key, value]) => params.append(key, value))
  const res = await api.post('getStandaloneRoute', params)
  if (res.data.status !== 1) throw new Error(res.data.msg || '独立航线已变化')
  return res.data
}

export async function dispatchDeliveryCommand (form) {
  const params = new URLSearchParams()
  Object.entries(form).forEach(([key, value]) => params.append(key, value))
  const res = await api.post('dispatchDeliveryCommand', params)
  if (res.data.status !== 1) throw new Error(res.data.msg)
  return res
}

export async function getDeliveryTask (form) {
  const params = new URLSearchParams()
  params.append('shop_id', form.shop_id)
  if (form.order_id) params.append('order_id', form.order_id)
  params.append('plane_id', form.plane_id)
  const res = await api.post('getDeliveryTask', params)
  if (res.data.status !== 1) throw new Error(res.data.msg || '当前任务核对失败')
  return res.data
}

/**
 * @description: 原子结束配送任务，后端释放站点槽位并更新订单
 */
export async function finishDeliveryTask (form, action = 'finishDeliveryTask') {
  const params = new URLSearchParams()
  Object.entries(form).forEach(([key, value]) => params.append(key, value || ''))
  const res = await api.post(action, params)
  if (res.data.status === 1) {
    store.commit('applyDeliveryTaskFinished', form)
    Message.success(t(res.data.msg))
  } else {
    Message.error(t(res.data.msg))
  }
  // A completed write stays successful even if a subsequent refresh fails.
  await Promise.allSettled(['fetchSiteList', 'fetchRouteList', 'fetchPaidOrderList'].map(action => store.dispatch(action)))
  return res
}

/**
 * @description: 向改变订单承接任务api 提交数据,参数可以是数组 提交多个字段和字段内容  () ，并更新订单列表
 * @param {*} id 订单id
 * @param {array string} type 主状态"main_status" 货物状态"shipment_status" 退款状态"refund_status" 执行飞机"by_plane_id"
 * @param {array string} val  修改字段的值 ps:by_plane_id值给'' 数据库改为null
 */
export async function questAss (id, type, val) {
  const params = new URLSearchParams()// post对象参数 转成 字符串连接
  params.append('id', id)
  // 判断 type 和 val 是否为数组
  if (Array.isArray(type) && Array.isArray(val)) {
    if (type.length !== val.length) {
      return
    }
    for (let i = 0; i < type.length; i++) {
      params.append(type[i], val[i])
    }
  } else if (typeof type === 'string' && typeof val === 'string') {
    params.append(type, val)
  } else {
    return
  }

  const res = await api.post('questAss', params)
  if (res.data.status === 1) {
    Message.success(t(res.data.msg))
    store.dispatch('fetchPaidOrderList')// 更新订单列表
  } else {
    Message.error(t(res.data.msg))
    store.dispatch('fetchPaidOrderList')// 更新订单列表
  }
  return res
}
/**
 * @description: 获取订单列表
 * @param {*} orderSearch 搜索条件
 */
export async function getOrderList (orderSearch = {}, action = 'getOrderList') {
  const params = new URLSearchParams()// post对象参数 转成 字符串连接
  const shopId = String(orderSearch.shop_id == null ? '' : orderSearch.shop_id).trim()
  if (shopId !== '' && shopId !== 'null' && shopId !== 'undefined') {
    params.append('shop_id', shopId)
  }
  params.append('start_time', orderSearch.start_time)
  params.append('end_time', orderSearch.end_time)
  params.append('main_status', orderSearch.main_status)
  if (orderSearch.exclude_canceled) params.append('exclude_canceled', '1')
  params.append('shipment_status', orderSearch.shipment_status)
  params.append('refund_status', orderSearch.refund_status)
  if (Array.isArray(orderSearch.archive_status) && orderSearch.archive_status.length > 0) {
    params.append('archive_status', orderSearch.archive_status.join(','))
  } else if (typeof orderSearch.archive_status === 'string' && orderSearch.archive_status !== '') {
    params.append('archive_status', orderSearch.archive_status)
  }
  params.append('search', orderSearch.search)
  if (orderSearch.page) {
    params.append('page', orderSearch.page)
  }
  if (orderSearch.page_size) {
    params.append('page_size', orderSearch.page_size)
  }
  // 发送查询订单列表请求
  const res = await api.post(action, params, 'Admin')
  return res
}

/**
 * @description: 获取订单详情
 * @param {*} order_id 订单id
 */
export async function getOrderDetails (id, action = 'getOrderDetails') {
  const params = new URLSearchParams()// post对象参数 转成 字符串连接
  params.append('id', id)
  // 发送查询订单详情 求情
  const res = await api.post(action, params, 'Admin')
  return res
}

/** 原子登记一次订单小票打印，并返回本次打印序号。 */
export async function recordOrderPrint (id, shopId) {
  const params = new URLSearchParams()
  params.append('id', id)
  params.append('shop_id', shopId)
  return api.post('recordOrderPrint', params, 'Admin')
}

/**
 * @description: 核对订单微信支付/退款回调状态
 * @param {*} id 订单 ID
 */
export async function checkOrderReconciliation (id) {
  const params = new URLSearchParams()
  params.append('id', id)
  const res = await api.post('checkOrderReconciliation', params, 'Admin')
  return res
}

/**
 * @description: 确认修正微信回调失败造成的订单状态不同步
 * @param {*} id 订单 ID
 * @param {*} fixType 修正类型
 */
export async function fixOrderReconciliation (id, fixType) {
  const params = new URLSearchParams()
  params.append('id', id)
  params.append('fix_type', fixType)
  const res = await api.post('fixOrderReconciliation', params, 'Admin')
  return res
}

/**
 * @description: 指定订单执行日终归档规则
 * @param {Array} orderIds 订单 ID 数组
 */
export async function archiveOrders (orderIds) {
  const params = new URLSearchParams()
  params.append('order_ids', (orderIds || []).join(','))
  const res = await api.post('archiveOrders', params, 'Admin')
  return res
}

/**
 * @description: 退款/取消订单函数
 * @param {*} orderSn 订单号
 * @param {*} shopId 商铺id
 * @param {*} refundPrice 退款金额（元）
 * @param {*} refundType 退款类型 'buyer'买家申请 'seller'卖家主动
 * @param {*} refundRemark 退款/取消原因（写入订单 refund_remark）
 */
export async function refund (orderSn, shopId, refundPrice, refundType, refundRemark = '', action = 'refund') {
  const params = new URLSearchParams()
  params.append('order_sn', orderSn)
  params.append('shop_id', shopId)
  params.append('refund_price', refundPrice)
  params.append('refund_type', refundType)
  params.append('refund_remark', refundRemark || '')

  const res = await api.post(action, params, 'Pay')
  if (res.data.status === 1) {
    Message.success(t(refundType === 'buyer' ? '退款已申请...' : '取消订单处理中...'))
    console.log('操作成功', res.data.msg)
  } else {
    Message.error(t(res.data.msg))
    console.error('操作失败:', res.data.msg)
  }
  return res
}

/**
 * @description: 向管理员用户发布公告
 * @param {*} shopId 商铺 ID
 * @param {*} tit 公告标题
 * @param {*} message 公告内容
 * @param {Array} idArr 接收公告的管理员 ID 数组，空数组代表所有人
 * @param {*} endTime 公告截止时间（时间戳，秒级）
 */
export async function pubMessage (shopId, tit, message, idArr, endTime) {
  const adminIds = Array.isArray(idArr) ? idArr : []
  const params = new URLSearchParams()
  params.append('shop_id', shopId)
  params.append('tit', tit)
  params.append('message', message)
  // admin_ids 是当前公告协议；idArr、end_time 保留为部署中旧接口的同义参数。
  params.append('admin_ids', JSON.stringify(adminIds))
  params.append('idArr', adminIds.join(','))
  params.append('endTime', endTime)
  params.append('end_time', endTime)

  const res = await api.post('pubMessage', params, 'Admin')
  return res
}

/**
 * @description 获取全部公告列表（不限制过期、无admin_id限制）
 * @returns {Promise} 返回接口响应对象
 */
export async function getAllMessageList () {
  const res = await api.get('getAllMessageList', 'Admin')
  return res
}

/**
 * @description 删除指定公告
 * @param {Array} delIdArr 要删除的公告 ID 数组
 * @returns {Promise}
 */
export async function delMessage (delIdArr) {
  const params = new URLSearchParams()
  params.append('delIdArr', delIdArr.join(',')) // 后端通过 $_POST['delIdArr'] 接收

  const res = await api.post('deleteMessage', params, 'Admin')
  return res
}

/**
 * @abstract 获取指定飞机组的飞行数据（按时间范围）
 * @param {Array} idArr 飞机ID数组
 * @param {Number} startTime 开始时间
 * @param {Number} endTime 结束时间
 * @returns 飞行数据列表
 */
export async function getFlyData (idArr, startTime, endTime) {
  const params = new URLSearchParams()
  params.append('idArr', idArr.join(',')) // 后端只收字符串，用逗号分隔
  params.append('startTime', startTime)
  params.append('endTime', endTime)

  const res = await api.post('getFlyDataByIdArr', params, 'Plane')
  return res
}

/**
 * @abstract 获取指定飞机组的历史日志（按时间范围）
 * @param {Array} planeIdArr 飞机ID数组
 * @param {Number} startTime 开始时间
 * @param {Number} endTime 结束时间
 * @returns 飞机日志列表
 */
export async function getFlyLog (planeIdArr, startTime, endTime, options = {}) {
  const params = new URLSearchParams()
  params.append('idArr', planeIdArr.join(','))
  params.append('startTime', startTime)
  params.append('endTime', endTime)
  params.append('limit', options.limit || 100)
  if (options.beforeTime && options.beforeId) {
    params.append('beforeTime', options.beforeTime)
    params.append('beforeId', options.beforeId)
  }

  const res = await api.post('getFlyLogByIdArr', params, 'Plane')
  return res
}
/**
 * @abstract 删除指定的飞行数据记录
 * @param {Array} idArr 飞行数据记录ID数组
 * @returns 删除结果
 */
export async function deleteFlyLogByRange (planeIds, startTime, endTime) {
  const params = new URLSearchParams()
  params.append('idArr', planeIds.join(','))
  params.append('startTime', startTime)
  params.append('endTime', endTime)
  return api.post('deleteFlyLogByRange', params, 'Plane')
}

export async function deleteFlyData (idArr) {
  if (!Array.isArray(idArr) || idArr.length === 0) {
    throw new Error('参数错误，idArr 应为非空数组')
  }

  const params = new URLSearchParams()
  params.append('idArr', idArr.join(',')) // 逗号分隔传给后端

  const res = await api.post('deleteFlyDataByIdArr', params, 'Plane')
  return res
}

/**
 * @description: 保存禁飞区数据
 * @param {Array} nofly_data 禁飞区数据数组
 * @returns {Object|null} 返回接口响应数据 或 null 表示失败
 */
export async function setNoflyData (noflyData) {
  try {
    const params = new URLSearchParams()
    params.append('restriction_type', 'nofly')
    params.append('regions', JSON.stringify((noflyData || []).map(coordinates => ({ coordinates }))))

    const res = await api.post('setNoflyData', params, 'God')
    if (res.data.status === 1) {
      store.dispatch('fetchNoflyData')// 更新平台级禁限飞区数据
      Message.success(t(res.data.msg))
    } else {
      Message.warning(t(res.data.msg))
    }
    return res.data
  } catch (error) {
    Message.error(t('保存禁飞区数据失败'))
    return null
  }
}

/**
 * @description: 保存限飞区数据
 * @param {Array} restrictfly_data 限制飞区数据数组
 * @param {Array} restrictfly_height 限制飞区数据高度组
 * @returns {Object|null} 返回接口响应数据 或 null 表示失败
 */
export async function setRestrictflyData (restrictflyData, restrictflyHeight) {
  try {
    const params = new URLSearchParams()
    params.append('restriction_type', 'restricted')
    params.append('regions', JSON.stringify((restrictflyData || []).map((coordinates, index) => ({
      coordinates,
      limit_height: Number(restrictflyHeight[index]) || 0
    }))))

    const res = await api.post('setNoflyData', params, 'God')
    if (res.data.status === 1) {
      store.dispatch('fetchNoflyData')// 更新平台级禁限飞区数据
      Message.success(t(res.data.msg))
    } else {
      Message.warning(t(res.data.msg))
    }
    return res.data
  } catch (error) {
    Message.error(t('保存限飞区数据失败'))
    return null
  }
}
